import styled from 'styled-components'

import { Header2 } from '~design-system'

const ModalTitle = styled(Header2)`
  font-weight: normal;
`

export default ModalTitle
